import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import PartnerForm from "./PartnerForm";
import { getPartnerDetails } from "../../../slices/partner/action";
import { useDispatch } from "react-redux";
const PartnerProfile = ({}) => {
  const dispatch = useDispatch();
  const [partnerDetails, setPartnerDetails] = useState({});

  useEffect(() => {
    getPartnerDetailsFunc();
  }, []);

  const getPartnerDetailsFunc = async () => {
    try {
      const res = await getPartnerDetails({}, dispatch);
      setPartnerDetails(res);
    } catch (error) {}
  };

  const handleUpdate = () => {};

  return (
    <Container className="p-4">
      <PartnerForm
        partnerDetails={partnerDetails}
        handleUpdate={handleUpdate}
      />
    </Container>
  );
};

export default PartnerProfile;
